const eclipsesData = value => {
  return {
      type: 'ECLIPSES_DATA',
      data: value
    };
}
export default eclipsesData;
